module.exports = __webpack_public_path__ + "static/img/example-img2.210089cb.ccbc6f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/logo/example-img2.210089cb.png
// module id = eSTp
// module chunks = 69